module.exports = "<horizontal-navigation-bar></horizontal-navigation-bar>\n<ui-view></ui-view>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/support/components/support/support.component.html
// module id = 762
// module chunks = 0